import { SelectField } from '@ff-it/form';
import { Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { InvoiceType } from 'modules/invoicing/common/types';
import { ReactElement } from 'react';

interface RowConfig {
  id?: number;
  type: InvoiceType;
  domain: 'LOCAL' | 'EU' | 'OTHER';
  vat_rate: number;
  nomenclature: string;
  operation: string;
}

interface NomenclatureOption {
  id: string;
  name: string;
  unit: string;
  vat: string;
}

interface OperationOption {
  id: string;
  kind: string;
}

export interface RowOptions {
  nomenclature: NomenclatureOption[];
  operations: OperationOption[];
}

export interface RowProps {
  items: RowConfig[];
  options: RowOptions;
}

const nomenclatureSelectProps = {
  simple: true,
  size: 'sm' as const,
  getOptionLabel: ({ name, vat }: NomenclatureOption) => `${name} (${vat})`,
  getOptionValue: (a: NomenclatureOption) => a.id,
};

const operationSelectProps = {
  simple: true,
  size: 'sm' as const,
  getOptionLabel: ({ id }: OperationOption) => `${id}`,
  getOptionValue: (a: OperationOption) => a.id,
};

export function Rows({ items, options: { nomenclature, operations } }: RowProps): ReactElement {
  return (
    <>
      <h5>Rows</h5>
      <Table>
        <Thead>
          <Tr>
            <Th>Type</Th>
            <Th>Domain</Th>
            <Th textAlign="right">VAT rate</Th>
            <Th>Nomenclature</Th>
            <Th>Operation</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map(({ type, domain, vat_rate }, i) => (
            <Tr key={i}>
              <Td valign="middle">{type}</Td>
              <Td valign="middle">{domain}</Td>
              <Td valign="middle" textAlign="right">
                {vat_rate}%
              </Td>
              <Td>
                <SelectField
                  name={`row[${i}].nomenclature`}
                  options={nomenclature}
                  {...nomenclatureSelectProps}
                  className="mb-0"
                />
              </Td>
              <Td>
                <SelectField
                  name={`row[${i}].operation`}
                  options={operations}
                  {...operationSelectProps}
                  className="mb-0"
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  );
}
